if (!customElements.get('collection-banner-media')) {
  customElements.define(
    'collection-banner-media',
    class CollectionBannerMedia extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(min-width: 900px)');
        this.onChange = this.syncViewport.bind(this);
        this.mediaQuery.addEventListener('change', this.onChange);
        this.syncViewport();
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.onChange);
      }

      syncViewport() {
        const isDesktop = this.mediaQuery.matches;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const videos = this.querySelectorAll('[data-banner-video]');

        videos.forEach((video) => {
          const viewport = video.dataset.bannerViewport || 'all';
          const shouldActivate =
            viewport === 'all' ||
            (isDesktop && viewport === 'desktop') ||
            (!isDesktop && viewport === 'mobile');

          if (shouldActivate && !reduceMotion) {
            this.activateVideo(video);
          } else {
            this.deactivateVideo(video);
          }
        });
      }

      activateVideo(video) {
        const shell = video.closest('.collection-meta-banner__video-shell');
        const sources = [...video.querySelectorAll('source[data-src]')];
        const preferHighQuality = video.dataset.preferHighQuality === 'true';

        const assignSources = (list) => {
          list.forEach((source) => {
            if (!source.getAttribute('src')) {
              source.setAttribute('src', source.getAttribute('data-src'));
            }
          });
        };

        if (sources.length) {
          // High-quality: load only the first (largest MP4) so HLS soft start is skipped.
          assignSources(preferHighQuality ? sources.slice(0, 1) : sources);
        } else if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
        }

        video.load();
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if (shell) shell.classList.add('is-playing');
            })
            .catch(() => {
              if (preferHighQuality && sources.length > 1) {
                assignSources(sources);
                video.load();
                const retry = video.play();
                if (retry && typeof retry.then === 'function') {
                  retry
                    .then(() => {
                      if (shell) shell.classList.add('is-playing');
                    })
                    .catch(() => {});
                }
              }
            });
        } else if (shell) {
          shell.classList.add('is-playing');
        }
      }

      deactivateVideo(video) {
        const shell = video.closest('.collection-meta-banner__video-shell');
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source[src]').forEach((source) => {
          source.removeAttribute('src');
        });
        video.load();
        if (shell) shell.classList.remove('is-playing');
      }
    }
  );
}
